import fuzzysearch from 'fuzzysearch';
import { createEmptyBlock } from 'lib-knowledge-document-structure';
import {
  deleteText,
  getNodeString,
  insertNodes,
  removeNodes,
  select,
  withoutNormalizing,
} from 'lib-knowledge-document-structure/plate/common';
import { getEmptyTableNode } from 'lib-knowledge-document-structure/plate/table';
import {
  ELEMENT_PARAGRAPH,
  ELEMENT_TABLE,
  MyEditor,
  MyElementOrText,
  MyRootBlock,
  MyTableElement,
  MyValue,
} from 'lib-knowledge-document-structure/plateTypes';
import { Point } from 'lib-knowledge-document-structure/slate/package';

import { Block, Blocks } from './shortcut.blocks';

export function filterBlocks(filter: string): ReadonlyArray<Block> {
  let loweredFilter = filter.toLocaleLowerCase();
  // Remove the slash
  loweredFilter = loweredFilter.startsWith('/')
    ? loweredFilter.slice(1)
    : loweredFilter;

  if (!loweredFilter) return Blocks;
  return Blocks.filter((b) =>
    fuzzysearch(loweredFilter, b.label.toLowerCase()),
  );
}

export function slashBlockToElement(block: Block): MyRootBlock {
  return createEmptyBlock(block.type);
}

/**
 * This inserts a new block of type "block" OR if the block it's triggered from
 * (oldBlockState) is empty then change the current block.
 */
export const runShortcut = ({
  editor,
  block,
  point,
  newLine,
  oldNodeState,
}: {
  editor: MyEditor;
  block: Block;
  point: Point;
  newLine: boolean;
  oldNodeState: MyElementOrText;
}): void => {
  if (block.insertAction) {
    withoutNormalizing(editor, () => {
      if (!newLine) {
        removeNodes(editor, { at: point.path });
        insertNodes(editor, oldNodeState, {
          at: point.path,
        });
        select(editor, point);
      }
      block.insertAction!({ point, editor });
    });
    return;
  }

  const newElement =
    block.type === ELEMENT_TABLE
      ? (getEmptyTableNode(editor, {
          rowCount: 3,
          colCount: 2,
        }) as MyTableElement)
      : slashBlockToElement(block);

  // Put in a block row afterwards if we insert things like a divider
  const isVoid = editor.isVoid(newElement);
  const nodes: MyValue = isVoid
    ? [newElement, createEmptyBlock(ELEMENT_PARAGRAPH)]
    : [newElement];

  if (newLine) {
    // Insert node below,
    const newPath = [point.path[0] + 1];
    insertNodes(editor, nodes, {
      at: newPath,
      select: true,
    });
    return;
  }

  // Row had existing text, so create new row.
  if (getNodeString(oldNodeState).length > 0) {
    // First remove the slash text
    withoutNormalizing(editor, () => {
      removeNodes(editor, { at: point.path });
      insertNodes(editor, oldNodeState, {
        at: point.path,
      });
      // Then insert the new row
      insertNodes(editor, nodes, {
        at: [point.path[0] + 1],
        select: true,
      });
    });
  } else {
    // Row is empty so change the type of node.
    withoutNormalizing(editor, () => {
      deleteText(editor, { at: [point.path[0]] });
      insertNodes(editor, nodes, {
        at: [point.path[0]],
        select: true,
      });
    });
  }
};
